import React from "react";
import { ReactSVG } from "react-svg";
const SvgIcon = (props) => {
  const { name, colorStyle } = props;
  let icon = require(`../assets/images/icons/default.svg`).default;
  let changeColor = colorStyle ? colorStyle : 'default';
  try {
    icon = require(`../assets/images/icons/${name}.svg`);
  } catch (e) {
    // icon = require(`../assets/images/icons/default.svg`);
  }
  return (
    <ReactSVG
      beforeInjection={(svg) => {
        svg.classList.add(`${changeColor}`);
      }}
      src={icon}
    />
  );
};

export default SvgIcon;
